import { useFavoriteServiceState } from '@kc-console/context';

/** 주석 작성
 * ~~~을 콘솔 레이아웃에 맞게 재정의하여 제공하는 훅입니다.
 * @description
 * -
 */

export const MAX_FAVORITE_SERVICE_COUNT = 20;

export const useRefinedFavoriteServiceState = () => {
  const { data } = useFavoriteServiceState();

  return { favoriteServices: data };
};
